function SitemapForm() {
  return <div />;
}

export default SitemapForm;
